// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    GIFT_PAGE_LOADING() {
      return {
        isLoading: true,
        giftPage: action.giftPage
      };
    },
    GIFT_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const adModelData = buildPostAdModel(adsConfig, site, 'gift', 'giftPage');

      return {
        isLoading: false,
        data: action.homepage,
        ads: adModelData
      };
    },
    GIFT_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.giftPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
